module.exports = __webpack_public_path__ + "img/tablet_reagendamiento_reagendado.bd0948da.png";